<template>
<v-dialog v-model="show" max-width="800" scrollable>
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on">
      <v-btn v-on="on" color="secondary">Results Emails</v-btn>
    </slot>
  </template>
  <v-card>
    <CardTitle title="Results Emails">
      <template v-slot:actions>
        <v-btn @click="show = false" icon><v-icon>close</v-icon></v-btn>
      </template>
    </CardTitle>
    <v-card-text>
      <v-data-iterator :items="released" disable-pagination hide-default-footer>
        <template v-slot:default="{items}">
          <v-row v-for="(customer, index) in items" :key="index" no-gutters>
            <v-col class="mb-3">
              <EmailForm :preview="preview" :customer="customer" @update_sample="updateSample(...$event)" @update_customer="updateCustomer(...$event)" @send="sendSpecific" @delete_email="deleteEmail($event)" @delete_sample_email="deleteSampleEmail($event)"></EmailForm>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-card-text>
    <CardActions v-if="!preview" @close="show = false" @submit="sendAll" submit_text="Send All"></CardActions>
    <v-overlay v-if="loading" absolute>
      <v-progress-circular indeterminate></v-progress-circular>
      {{ loadingMessage }}
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <v-btn v-on="on" @click="show = false" icon outlined><v-icon>close</v-icon></v-btn>
        </template>
        <span>Cancel and close</span>
      </v-tooltip>
    </v-overlay>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "EmailDialog",
    components: {
      EmailForm: () => import('./EmailForm')
    },
    data: () => ({
      show: false,
      loading: false,
      loadingMessage: "Loading Successful Releases...",
      released: [],
      releaseQueue: []
    }),
    props:{
      preview: {
        type: Boolean,
        default: false,
      }
    },
    watch:{
      show(v){
        if(v){
          this.load()
        }else{
          this.released = []
        }
      }
    },
    methods: {
      async load(){
        this.released = [];
        this.loading = true;
        await this.loadReleasedSamples();
        this.loadingMessage = "Loading Sample Data...";
        let samples = await this.loadCustomerGroupedSamples();
        console.log(samples);
        this.loadingMessage = "Loading Customer Data...";
        await this.loadAndSetCustomers(samples);
        this.loading = false;
        this.loadingMessage = "Loading Successful Releases...";
      },
      async loadReleasedSamples(){
        let snapshot;
        if(false){
          snapshot = await this.$firestore.collection('release_sample').where('sample_uuid', 'in', ['8d414703-5f29-413a-ae28-706f73e410d5', '9699a4ac-2ed8-4277-b678-09666df2d179']).limit(5).get();
        }else{
          snapshot = await this.$firestore.collection('release_sample').where('email_sent', '!=', true).where('status', '==', 'Success').get();
        }
        // let snapshot = await this.$firestore.collection('release_sample').limit(10).get();
        this.releaseQueue = snapshot.docs.map(doc => {
          return doc.data().sample_uuid;
        })
      },
      async loadCustomerGroupedSamples(){
        if(this.releaseQueue.length === 0) return [];
        let chunkedReleases = this.chunkArray(this.releaseQueue, 50);
        // console.log(chunkedReleases, 'chunked releases');
        let response = [];
        for(let chunk of chunkedReleases){
          let query = await this.$store.$db().model('samples').api().fetch({
            where_in: {
              key: "uuid",
              values: chunk,
            },
            with: 'sampleNotes',
            group_by: "customer_id"
          }, "", null, false)
          response.push(query.response.data);
        }
        // console.log(response)
        // console.log()
        return response.reduce((obj, v) => {
          let keys = Object.keys(v)
          for(let key of keys){
            if(obj[key]){
              obj[key] = [...obj[key], ...v[key]]
            }else{
              obj[key] = v[key]
            }
          }
          return obj;
        }, {})
      },
      async loadAndSetCustomers(group){
        if(group.length === 0) return [];
        let samplesByCustomer = [];
        for(let customer_id in group){
          if(this.$store.state.ReleaseSampleStore.customersWaitingForRelease[customer_id]) continue;
          let customer = await this.$store.$db().model('customers').api().fetch({
            where: {
              key: "id",
              value: customer_id
            },
            with: 'contactsWithSubscriptions,primaryName',
            limit: 1,
          }, "", null, false);
          if(customer.response.data && customer.response.data.length > 0){
            customer = customer.response.data[0];
            samplesByCustomer.push({
              loading: false,
              id: customer_id,
              name: customer.primary_name.name,
              contacts: this.filterContacts(customer.contacts_with_subscriptions),
              samples: group[customer_id]
            })
          }
        }
        this.released = samplesByCustomer;
      },
      filterContacts(contacts){
        return contacts.filter(contact => {
          return (contact.email !== null || contact.alt_email !== null)
              && contact.email_subscriptions.some(subscription => subscription.email_type_id === 5 && subscription.deleted_at === null)
        }).map(contact => {
          if(!contact.email){
            return contact.alt_email
          }
          return contact.email
        })
      },
      updateSample(sample_uuid, update){
        this.released.forEach((customer, key) => {
          let findIndex = customer.samples.findIndex(({uuid}) => uuid === sample_uuid);
          if(findIndex !== -1){
            this.$set(this.released[key].samples, findIndex, {...this.released[key].samples[findIndex], ... update});
            return;
          }
        })
      },
      updateCustomer(customer_id, update){
        let findIndex = this.released.findIndex(({id}) => id === customer_id);
        if(findIndex !== -1){
          this.$set(this.released, findIndex, {...this.released[findIndex], ...update})
        }
      },
      async sendSpecific(customer){
        if(this.preview){
          this.$store.dispatch("showError", "Sending emails in preview is disabled.")
          return;
        }
        customer.loading = true;
        customer.dont_send = true;
        let findIndex = this.released.findIndex(({id}) => id === customer.id);
        let email = {
          bcc: "info@conflabs.com",
          samples: customer.samples.map(sample => sample.uuid),
          to: customer.contacts,
          message: customer.email.message
        }
        await this.$firestore.collection('mail').add(email);
        let markSent = this.markEmailed(email);
        await markSent.commit();
        customer.loading = false;
        this.released.splice(findIndex,1);
      },
      async sendAll(){
        if(this.preview){
          this.$store.dispatch("showError", "Sending emails in preview is disabled.")
          return;
        }
        this.loading = true;
        this.loadingMessage = "Sending Bulk Emails..."
        let emails = this.released.filter(val => !val.dont_send && val.email).map(cust => ({
          bcc: "info@conflabs.com",
          samples: cust.samples.map(sample => sample.uuid),
          to: cust.contacts,
          message: cust.email.message
        }));
        let batch = this.$firestore.batch();
        let sent = [];
        for(let email of emails){
          let ref = this.$firestore.collection('mail').doc();
          batch.set(ref, email);
          sent.push(this.markEmailed(email))
        }
        await batch.commit();
        await Promise.all(sent.map(b => b.commit()));
        this.loading = false;
        this.loadingMessage =  "Loading Successful Releases...";
        this.load().catch(e => console.log(e));
      },
      markEmailed(email){
        let batch = this.$firestore.batch();
        for(let sample of email.samples){
          let ref = this.$firestore.collection('release_sample').doc(sample);
          batch.update(ref, {email_sent: true})
        }
        return batch;
      },
      async deleteEmail(samples) {
        let batch = this.markEmailed({samples});
        await batch.commit();
        if(samples.length > 0){
          let customer = samples[0].customer_id;
          let findIndex = this.released.findIndex(({id}) => id === customer);
          this.released.splice(findIndex, 1)
        }


      },
      async deleteSampleEmail(sample){
        let batch = this.markEmailed({samples: [sample]});
        await batch.commit();
      },
      chunkArray(array, size){
        return Array.from({length: Math.ceil(array.length / size)}, (value, index) => {
          return array.slice(index * size, index * size + size);
        })
      },
    },
}
</script>

<style scoped>

</style>
